import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionHeroComponent } from './section-hero.component';



@NgModule({
  declarations: [
    SectionHeroComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [SectionHeroComponent]
})
export class SectionHeroModule { }

export interface HeroInfo {
  backgroundImage: string;
  backgroundPositionY: string;
  backgroundColor: string;
  showTitle: boolean;
  title: string;
  showSubtitle: boolean;
  subtitle: string;
  showButton1: boolean;
  button1Text: string;
  button1Link: string;
  showButton2: boolean;
  button2Text: string;
  button2Link: string;
};

